import { OidcUser } from '../types/oidcUser';

export const getOrganizationId = (user: OidcUser | null | undefined) => {
  return (
    user?.profile?.organization.find((org) => org.isDefault)?.id ||
    user?.profile?.organization?.[0]?.id ||
    ''
  );
};

export const isUserAdmin = (
  user: OidcUser | null | undefined,
  organizationId: string,
): boolean => {
  const currentOrganization = user?.profile?.organization?.find(
    (org) => org.id === organizationId,
  );

  return (
    currentOrganization?.roles?.some(
      (role) => role.name.toLowerCase() === 'admin',
    ) || false
  );
};
